
export function getRandom(min: number, max: number) {
	return Math.random() * (max - min) + min;
}

export function getFormattedNumber(value: number, decimals: number = 2): string {
	if (!value && value !== 0) {
		return '';
	}

	// Fix to specified decimal places, then remove trailing zeros
	return value.toFixed(decimals).replace(/\.?0+$/, '');
}

/**
 * Formats a number to a string with specified decimal places, removing unnecessary trailing zeros
 * Examples:
 * - formatNumberWithoutTrailingZeros(52.00, 2) -> "52"
 * - formatNumberWithoutTrailingZeros(52.30, 2) -> "52.3"
 * - formatNumberWithoutTrailingZeros(52.34, 2) -> "52.34"
 * - formatNumberWithoutTrailingZeros(52, 2) -> "52"
 */
export function formatNumberWithoutTrailingZeros(value: number, decimals: number = 2): string {
	if (value === undefined || value === null || isNaN(value)) {
		return '0';
	}

	// Fix to specified decimal places, then remove trailing zeros and decimal point if not needed
	return value.toFixed(decimals).replace(/\.?0+$/, '');
}

export function valueFromPercentage(percent: number, totalValue: number, decimals?: number) {
	const value =  (percent / 100) * totalValue;

	if (!decimals || !value) {
		return value;
	}

	return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);

}

export function toPercentage(value: number, total: number, decimals?: number) {
	if (!value || !total) {
		return value
	}

	const percentage = (value * 100) / total;

	if (!decimals || !percentage) {
		return percentage;
	}

	return Math.round(percentage * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

